export { default as Boolean } from 'fixedassets/components/detail/field/DetailFieldBoolean';
export { default as Catalog } from 'fixedassets/components/detail/field/DetailFieldCatalog';
export { default as Currency } from 'fixedassets/components/detail/field/DetailFieldCurrency';
export { default as Date } from 'fixedassets/components/detail/field/DetailFieldDate';
export { default as DateTime } from 'fixedassets/components/detail/field/DetailFieldDateTime';
export { default as Number } from 'fixedassets/components/detail/field/DetailFieldNumber';
export { default as Relation } from 'fixedassets/components/detail/field/DetailFieldRelation';
export { default as Text } from 'fixedassets/components/detail/field/DetailFieldText';



// WEBPACK FOOTER //
// src/modules/secured/modules/fixedassets/components/detail/field/index.js